<template>
    <section class="wrapper-guide">
        <div :class="['guide', {'guide--small' : steps.length < 3}]">
            <div v-for="(text, index) in steps"
                :key="index"
                class="step"
            >
                <div class="step__number">{{ index + 1 }}</div>
                <div :class="['step__text', {'step__text--no-max-width': noMaxWidth}]">
                    {{ text }}
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'kyc-guide',
    props: {
        steps: {
            type: Array,
            default: () => ([]),
        },
        noMaxWidth: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper-guide {
    width: 100%;
}

.guide {
    margin: 2.4rem -1rem 4rem;
    border-radius: 1rem;
    display: flex;
    justify-content: space-between;
    padding: 2rem 1.65rem;
    background: rgba($alto-color, 0.1);
    border: 0.1rem solid $mercury-color;

    &--small {
        justify-content: space-around;
    }

    @include max-width(sm) {
        flex-wrap: wrap;
        justify-content: center;
    }
}

.step {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 2rem;

    &:last-of-type {
        margin-right: 0;
    }

    @include max-width(sm) {
        margin-bottom: 2rem;
        margin-right: 0;

        &:last-of-type {
            margin-bottom: 0;
        }
    }

    @include min-width(lg) {
        flex-direction: row;
        justify-content: space-around;
        align-items: flex-start;
    }

    &__number {
        min-width: 2.5rem;
        width: 2.5rem;
        height: 2.5rem;
        line-height: 2.5rem;
        font-size: 1.5rem;
        color: $azure-radiance-color;
        border-radius: 100%;
        border: 0.15rem solid $azure-radiance-color;
        position: relative;
        top: -0.5rem;
        text-align: center;
        margin-right: 1rem;
    }

    &__text {
        max-width: 19.6rem;
        color: $cyprus-color;
        font-size: 1.2rem;
        line-height: 1.7rem;

        &--no-max-width {
            max-width: unset;
        }
    }
}
</style>